import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IComponentController } from 'angular';

interface IPageRc2002 extends IComponentController {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    valeursEcran: any;
    context: any; //valeur recue par dialog-ecran
}

/* @ngInject */
export default function Rc2002Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    Menu: IMenuClass,
    MenuItemForage: IMenuItemForageClass,
    rc2006Route: IRoute,
    ac0010Route: IRoute,
) {

    const vm: IPageRc2002 = this;

    vm.$onInit = $onInit;
    vm.valeursEcran = ecranDetails.valeurs;

    function $onInit() {
        const docAchat = [
            new MenuItemForage(
                'BTN_FORAGE_PFL',
                ac0010Route.NAME,
                (rowData:any) => ({
                    id: rowData.doccleintref
                }),
                { 
                    fonction:'BOUDAC',
                    icon:'exit_to_app'
                }
            )
        ];

        vm.multiOccurrenceOptions = {
            fonctions: {
                rechercheCollapsable: false,
                reinitialiserOuvrirCriteres: true,
                criteresSuggeresVisibles: true,
                effaceCriteres: true
            },
            criteresSuggeres: new Formulaire([
                new FormulaireItem('refcleint'),
                new FormulaireItem('dacnumdoc2'),
                new FormulaireItem('daccleint', {
                    resourceParams: (data:any) => ({
                        refcleint: data.refcleint
                    })
                }),
                new FormulaireItem('sysboncmd', {
                    resourceParams: (data:any) => ({
                        daccleint: data.daccleint
                    })
                }),
                new FormulaireItem('doccleint_txm', {
                    resourceParams: (data:any) => ({
                        refcleint: data.refcleint,
                        daccleint: data.daccleint
                    })
                }),
                new FormulaireItem('magcleint', {
                    resourceParams: () => ({
                        intcleintreq: vm.valeursEcran.intcleintreq
                    })
                }),
                new FormulaireItem('intcleintmag', {
                    resourceParams: (data:any) => ({
                        magcleint: data.magcleint
                    })
                }),
                new FormulaireItem('procleint'),
                new FormulaireItem('daidsc'),
            ]),
            actionsRangeeDroite: new Menu([
                new MenuItemForage(
                    'LBL_BTN_TXM',
                    rc2006Route.NAME,
                    (rowData: any) => ({
                        id: rowData.daccleint,
                        daccleint: rowData.daccleint,
                        intcleintmag: vm.multiOccurrence.etatSelected.criteresSuggeresData.intcleintmag
                    }),
                    {
                        fonction: 'BOUTXM',
                        icon: 'add_circle',
                        iconButton: true
                    }
                )
            ]),
            colonnesVisibles: [
                { nom: 'tydcodref', largeur: 80 },
                { nom: 'dacnumdoc', largeur: 140, menu: docAchat },
                { nom: 'sysbnc', largeur: 150 },
                { nom: 'refcod', largeur: 120 },
                { nom: 'refnom', largeur: 220 },
                { nom: 'dacdat', largeur: 126 },
                { nom: 'intcodreq', largeur: 120 },
                { nom: 'intnomreq', largeur: 220 }
            ],
            colonnesCachees: [
                'doccleintref',
            ]
        };
    }
}
